<template>
    <v-main>
        <div v-if="$route.params.hash && student && lessons">
            <v-col md="10" offset-md="1" cols="12" offset="0" class="py-0 px-0">
                <h1 class="pl-6 pt-6 pb-2">{{student.first_name}} {{student.last_name}}</h1>
                <v-row class="no-gutters">
                    <h2 cols="auto" class="pl-6 pt-6 pb-4">Timetable</h2>
                    <v-col cols="grow" align-self="end" align="right" class="px-5">
                        <v-btn
                          v-for="assignment in student.assignments.filter(a => a.count)"
                          :key="assignment.id"
                          hover="true"
                          small
                          text
                          outlined
                          class="mx-1 mb-3"
                          :color="assignment.color"
                          col="auto"
                          :style="{opacity: assignment.count > 0 ? '100%' : '30%'}">
                            {{ assignment.count }} &times; {{ assignment.name }}
                        </v-btn>
                    </v-col>
                </v-row>
                <v-card class="px-3 py-1 pt-md-2 pb-md-2" :style="{'border-radius': $vuetify.breakpoint.mdAndUp ? '22pt !important' : null}" outlined>
                    <v-simple-table>
                        <tbody class="no_hover">
                            <tr>
                                <th v-for="lesson in lessons" :key="'h' + lesson.id" class="pa-0 pa-sm-1 pa-lg-2" style="text-align:center; white-space: nowrap">
                                    {{ lesson.day.slice(0, 3) }}
                                    <br>
                                    {{ $vuetify.breakpoint.xs ? lesson.start_time : lesson.start_time + '&ndash;' + lesson.end_time }}
                                </th>
                            </tr>
                            <tr>
                                <td v-for="lesson_state in lessons_states" class="pa-0" :key="'c' + lesson_state.id + lesson_state.id" style="text-align: center; vertical-align: middle">
                                    <school-icon dark :training_state="lesson_state.state.training" :school_state="lesson_state.state.school"/>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>
                <div class="text-right body-2 font-italic text--secondary pt-2 pr-2" v-html="validity_message"></div>
                <h2 class="pl-6 pt-6 pb-4" v-if="student.events.length && (future_events + current_events).length">Events</h2>
                <v-list :rounded="$vuetify.breakpoint.mdAndUp" class="pa-md-0 py-0 px-2" :style="{'border-radius': $vuetify.breakpoint.mdAndUp ? '22pt !important' : null}">
                    <v-subheader v-if="current_events && current_events.length > 0">Current</v-subheader>
                    <v-list-item v-for="ev in current_events" :key="ev.start_date">
                            <v-list-item-avatar>
                                <v-btn fab color="primary">
                                    <v-icon v-text="ev.type.icon"/>
                                </v-btn>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title v-text="ev.name"></v-list-item-title>
                                <v-list-item-subtitle><i>{{ Math.abs(Math.floor( (Date.parse(ev.end_date) - Date.now())  / (1e3 * 60 * 60 * 24) )) }}d left</i></v-list-item-subtitle>
                            </v-list-item-content>
                    </v-list-item>
                    <v-subheader v-if="future_events && future_events.length > 0">Upcoming</v-subheader>
                    <v-list-item v-for="ev in future_events" :key="ev.start_date">
                            <v-list-item-avatar>
                                <v-btn fab color="primary">
                                    <v-icon v-text="ev.type.icon"/>
                                </v-btn>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <!-- <v-list-item-title v-text="ev.type.name[0].toUpperCase() + ev.type.name.slice(1)"></v-list-item-title> -->
                                <v-list-item-title v-text="ev.name"></v-list-item-title>
                                <v-list-item-subtitle><i>in {{ Math.abs(Math.floor( (Date.parse(ev.start_date) - Date.now())  / (1e3 * 60 * 60 * 24) )) }}d</i></v-list-item-subtitle>
                            </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-col>
        </div>
        <v-snackbar app v-model="snackbar">
            <v-icon left>error</v-icon>
            {{ snackbar_msg }}
        </v-snackbar>
    </v-main>
</template>

<script>

import axios from 'axios'

import SchoolIcon from '../components/student/SchoolIcon.vue'

export default {
    name: 'StudentView',

    components: {
        SchoolIcon
    },

    data: () => ({
        student: null,
        lessons: null,
        start_date: null,
        end_date: null,
        snackbar_msg: '',
        snackbar: false
    }),

    methods: {
        format_date (iso_date) {
            var date = new Date(iso_date)
            var date_string = date.toDateString().split(' ')
            return date_string[1] + ' ' + parseInt(date_string[2], 10)
        }
    },
    computed: {
        lessons_states () {
            return this.lessons.map(l =>
                this.student.lessons.find(sl => sl.id == l.id)
            )
        },
        current_events () {
            return this.student.events.filter(e => (Date.parse(e.start_date) - Date.now() <= 0.) && (Date.parse(e.end_date) - Date.now() >= 0.))
        },
        future_events () {
            return this.student.events.filter(e => (Date.parse(e.start_date) - Date.now() >= 0.) && (Date.parse(e.end_date) - Date.now() >= 0.))
        },
        validity_message () {
            if (this.start_date && this.end_date) {
                return "valid " + this.format_date(this.start_date) + " &ndash; " + this.format_date(this.end_date)
            } else if (this.start_date) {
                return "valid from " + this.format_date(this.start_date)
            } else if (this.end_date) {
                return "valid until " + this.format_date(this.end_date)
            } else {
                return null
            }
        }
    },
    async created () {
        try {
            var r = await axios.get(this.$store.getters['api/api_base'] + 'student/' + this.$route.params.hash);
            this.lessons = r.data.lessons;
            this.student = r.data.student;
            this.start_date = r.data.validity.start_date;
            this.end_date = r.data.validity.end_date;
            if (window.localStorage.getItem('hash') === null) {
                window.localStorage.setItem('type', 'student');
                window.localStorage.setItem('hash', this.$route.params.hash);
            }
        } catch (e) {
            if (e.response && e.response.status == 401) {
                if (this.$route.params.hash === window.localStorage.getItem('hash') && window.localStorage.getItem('type') == 'student'){
                    window.localStorage.removeItem('hash');
                    window.localStorage.removeItem('type');
                }
                this.$router.push({
                    path: '/error/unauthorized'
                });
            } else {
                this.snackbar_msg = 'Error fetching data';
                this.snackbar = true;
            }
        }
    }
};
</script>

<style lang="scss">

body {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10+ and Edge */
  user-select: none; /* Standard syntax */
}

.v-item-group.v-bottom-navigation .v-btn {
    height: inherit !important;
}

.no_hover {
   tr:hover {
      background-color: transparent !important;
   }
}
</style>
